import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const UploaderModalContainer = styled(Box, {
  name: 'uploader-modal-container',
  slot: 'Root',
})(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 480,
  maxWidth: '90vw',
  maxHeight: '90vh',
  display: 'flex',
  flexDirection: 'column',
  // Use the CSS-variable accessor (theme.vars) so the modal follows the active
  // color scheme. Reading theme.palette directly pins these to the default
  // (light) values, which left the container white in dark mode while the
  // inputs inside correctly went dark.
  backgroundColor: (theme.vars ?? theme).palette.background.paper,
  border: `1px solid ${(theme.vars ?? theme).palette.divider}`,
  borderRadius: (theme.shape.borderRadius as number) * 2,
  boxShadow: (theme.vars ?? theme).shadows[24],
  outline: 'none',
  overflow: 'hidden',
}));

export { UploaderModalContainer };
